module.exports = __webpack_public_path__ + "static/media/ed6448d2e49899cc.edc78429.png";